import { ReferenceContactId } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { stableQueryOptionsRpc } from "util/requests";

export interface ReferenceContactAiSummaryAccess {
    canManage: boolean;
}

export const useReferenceContactAiSummaryAccessQuery = (
    referenceContactId: ReferenceContactId | null,
) => {
    const trpcClient = trpc.useTRPC();

    return useQuery({
        ...trpcClient.referenceContactAiSummary.access.queryOptions({
            entityId: referenceContactId!,
        }),
        ...stableQueryOptionsRpc(),
        enabled: referenceContactId !== null,
    });
};

export const useReferenceContactAiSummaryAccess = (
    referenceContactId: ReferenceContactId | null,
): ReferenceContactAiSummaryAccess => {
    const accessQuery = useReferenceContactAiSummaryAccessQuery(referenceContactId);

    return { canManage: accessQuery.data?.canManage ?? false };
};
